import script from "./AppIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AppIcon.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__